import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_DISETUJUI,
  STATUS_PENGERJAAN_SELESAI,
  urlCreateREQ,
  urlUpdateREQ,
  urlVerifikasiTransaksi,
  STATUS_PENGERJAAN_PROSES,
  STATUS_PENGERJAAN_PENDING,
} from "../../helpers";
import { Alert } from "@material-ui/lab";
import { getIDunit } from "App/utils/cookies";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_AJUKAN = {
  label: "PENGAJUAN",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_DISETUJUI = {
  label: "SETUJUI",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_TOLAK = {
  label: "TOLAK",
  color: "danger",
  state: true,
  disabled: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_REVISI = {
  label: "REVISI",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_SELESAI = {
  label: "SELESAI",
  color: "green",
  state: true,
  disabled: false,
};

const ModalSimpan = ({ setShowModal, setNewDataReqList }) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledAjukan, setDisabledAjukan] = useState(SHOW_AJUKAN);

  const { formData, setFormData, listDetail } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    if(!isNull(getIDunit())){
        setFormData({
            ...formData,
            unit_id: getIDunit()
        })
    }else{

    }

    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.taggal_request) ||
        isNull(formData.gudang_id) ||
        isNull(formData.unit_id) ||
        isNull(formData.user_request)
      ) {
        switch (true) {
          case formData.taggal_request === "":
            defaultToastError("Harap pilih tanggal request !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.unit_id):
            defaultToastError("Harap pilih unit anda !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.user_request):
            defaultToastError("Username request dibutuhkan !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.gudang_id):
            defaultToastError("Gudang dibutuhkan !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          default:
            defaultToastError("Harap lengkapi form request!");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
        }
      } else {
        const api = await instance4.post(urlCreateREQ, {
          unit_id: formData.unit_id,
          gudang_id: formData.gudang_id,
          remark: formData.remark,
          taggal_request: toUTCFormat(formData.taggal_request),
          user_request: formData.user_request,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            id: res?.id,
            isOpenDraf: true,
            isProcess: false,
          });
          setNewDataReqList(res.id);
        } else {
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          defaultToastError(res?.message);
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.taggal_request === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdateREQ, {
          id: formData.id,
          unit_id: isNull(getIDunit()) ? formData.unit_id : getIDunit(),
          gudang_id: formData.gudang_id,
          remark: formData.remark,
          taggal_request: toUTCFormat(formData.taggal_request),
          user_request: formData.user_request,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setNewDataReqList(formData.id);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledUpdate(SHOW_UPDATE);
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickAjukan = async (e) => {
    e.preventDefault();
    setDisabledAjukan(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.taggal_request === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledAjukan(SHOW_AJUKAN);
      } else {
        if (listDetail.length === 0) {
          defaultToastError("List permintaan tidak boleh kosong!");
          setDisabledAjukan(SHOW_AJUKAN);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.id,
            status_request: STATUS_PENGERJAAN_PENGAJUAN,
            remark_recive: formData.remark_recive,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remark_recive: formData.remark_recive,
              status_request: STATUS_PENGERJAAN_PENGAJUAN,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledAjukan(SHOW_AJUKAN);
        }
      }
    } catch (error) {
      setDisabledAjukan(SHOW_AJUKAN);
      defaultToastError(error?.response?.data?.message);
    }
  };

  // const handleChange = (text) => (e) => {
  //   setFormData({
  //     ...formData,
  //     [text]: e.target.value,
  //   });
  // };
  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{ marginBottom: "1rem" }}>
        {/* {formData.status_request === STATUS_PENGERJAAN_DRAFT ? (
          <InputTextArea
            id="remark_verifikasi"
            label={"Keterangan/Catatan"}
            name=""
            className="mt-1 w-full"
            value={formData.remak_verifikasi2}
            placeholder={""}
            onChange={handleChange("remak_verifikasi2")}
            rows={"3"}
          />
        ) : (
          <></>
        )} */}
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          formData={formData}
          disabledOpenDraft={disabledOpenDraft}
          disabledUpdate={disabledUpdate}
          disabledAjukan={disabledAjukan}
          handleClickOpenDraf={handleClickOpenDraf}
          handleClickUpdate={handleClickUpdate}
          handleClickAjukan={handleClickAjukan}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  formData,
  disabledOpenDraft,
  disabledUpdate,
  disabledAjukan,
  handleClickOpenDraf,
  handleClickUpdate,
  handleClickAjukan,
}) => {
  return (
    <>
      {(isOpenDraf && !isNull(formData.id)) ||
      (!isOpenDraf && !isNull(formData.id)) ? (
        formData.status_request === STATUS_PENGERJAAN_DRAFT ? (
          <>
            <Alert severity='info' variant='outlined' style={{ width: "100%" }}>
              Harap lakukan update request ketika melakukan perubahan data
            </Alert>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) =>
                disabledUpdate.disabled ? null : handleClickUpdate(e)
              }
              name={disabledUpdate.label}
              size='lg'
            />

            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledAjukan.color}
              onClick={(e) =>
                disabledAjukan.disabled ? null : handleClickAjukan(e)
              }
              name={disabledAjukan.label}
              size='lg'
            />
          </>
        ) : formData.status_request === STATUS_PENGERJAAN_PENGAJUAN ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>PERMINTAAN DALAM PROSES PENGAJUAN</>
            </div>
          </>
        ) : formData.status_request === STATUS_PENGERJAAN_DISETUJUI ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>PERMINTAAN SUDAH DISETUJUI</>
            </div>
          </>
        ) : formData.status_request === STATUS_PENGERJAAN_PROSES ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>PERMINTAAN DALAM PRENGERJAAN</>
            </div>
          </>
        ) : formData.status_request === STATUS_PENGERJAAN_PENDING ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>PERMINTAAN SEDANG DIPENDING</>
            </div>
          </>
        ) : formData.status_request === STATUS_PENGERJAAN_SELESAI ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>PERMINTAAN TELAH SELESAI</>
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>PERMINTAAN DITOLAK</>
          </div>
        )
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) =>
            disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)
          }
          size='lg'
        />
      )}
    </>
  );
};

export default ModalSimpan;
